import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getCookie } from '@/utils/common.js';
import vi from '../lang/vi.json';
import en from '../lang/en.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getCookie('bfc_language') || 'vi',
  fallbackLocale: 'vi',
  messages: {
    vi,
    en,
  },
});

export default i18n;
